import { render, staticRenderFns } from "./AccountTransactionCards.vue?vue&type=template&id=13aa0d40&"
import script from "./AccountTransactionCards.vue?vue&type=script&lang=js&"
export * from "./AccountTransactionCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports